import type { AppRouteConfig } from '../../models'
import { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'
import { FeatureIdEnum } from '../../enums'
import { FiltersUtils } from '../../utils/filters.utils'
import { SearchEqualizeForm, SearchEqualizeList } from '../../views'
import { ROUTER_CONSTS } from '../router.consts'
import { ROUTES_PATHS } from '../routes.paths'

const NAMES = ROUTER_CONSTS.routes[FeatureIdEnum.EQUALIZE]

const PATHS = Object.assign(ROUTES_PATHS, {
  root: 'equalize',
})

const featureId = FeatureIdEnum.EQUALIZE

export const SEARCH_EQUALIZE_ROUTES: AppRouteConfig[] = [
  {
    name: NAMES.list,
    path: PATHS.root,
    component: SearchEqualizeList,
    meta: {
      featureId,
      filters: instance =>
        FiltersUtils.getFiltersByInstanceAndFeature(instance, featureId, DomainEnum.SEARCH),
      style: {
        removeContentPadding: true,
      },
    },
  },
  {
    name: NAMES.create,
    path: `${PATHS.root}/${PATHS.actions.create}`,
    component: SearchEqualizeForm,
    meta: {
      featureId,
      titleI18nKey: 'createEqualize',
      parentRouteName: NAMES.list,
    },
  },
  {
    name: NAMES.update,
    path: `${PATHS.root}/${PATHS.actions.update}`,
    component: SearchEqualizeForm,
    meta: {
      featureId,
      titleI18nKey: 'updateEqualize',
      parentRouteName: NAMES.list,
    },
  },
]
